<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import urlParser from '../services/url-parser'

export default {

  name: 'BaseButton',

  props: {
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    target: {
      type: String,
      default: 'self'
    },
    white: Boolean
  },

  computed: {
    _url () {
      return urlParser.getUrl(this.url)
    }
  },

  methods: {
    onClick (event) {
      if (urlParser.isInner(this._url) && !urlParser.isMail(this._url)) {
        event.preventDefault();
        this.$router.push(this._url);
      }
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

a.button(:href="_url", :target="target", @click="onClick($event)")
  div.container
    span.label(:class="{ 'is-white': white }") {{ label }}

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.button
  height 34px
  cursor pointer
  align-self flex-start

.container
  display inline-flex
  justify-content center
  align-items center
  height 100%

.label
  position relative
  font-weight 500
  font-size 16px
  line-height 23px
  color blue

  &.is-white
    color white

  &:after
    content ''
    position absolute
    left 0
    bottom -6px
    width 100%
    height 4px
    background orange

  +mobile()
    font-size 14px

  +hd()
    font-size 18px

</style>



// WEBPACK FOOTER //
// base-button.vue?1f721870